const MIN_YEAR_BUILT = 1600;
const MAX_ACRES = 500;
const MAX_LIVING_AREA = 50000;
const currentYear = new Date().getFullYear();

/**
 * Inventory update field protections. Add new entries to reject invalid user input
 * before updates are sent to the database.
 *
 * Each protection:
 * - fields: grid/inventory field names used across flows (Case Review vs Data Analysis)
 * - validate(value, updates, parcelId) => null if valid, or an error message string
 */
export const INVENTORY_UPDATE_VALIDATION_TOAST_OPTIONS = { autoClose: false };

export const INVENTORY_UPDATE_PROTECTIONS = [
  {
    fields: ['YearBuilt'],
    validate: (value) => {
      if (value == null || value === '') return null;
      const num = Number(value);
      if (Number.isNaN(num)) return 'Year Built must be a valid number.';
      if (num < MIN_YEAR_BUILT) return `Year Built cannot be less than ${MIN_YEAR_BUILT}.`;
      if (num > currentYear) return `Year Built cannot be greater than ${currentYear}.`;
      return null;
    },
  },
  {
    fields: ['Sqft', 'LivingArea'],
    validate: (value) => {
      if (value == null || value === '') return null;
      const num = Number(value);
      if (Number.isNaN(num)) return 'Living Area must be a valid number.';
      if (num < 100) return 'Living Area cannot be less than 100.';
      if (num > MAX_LIVING_AREA) return `Living Area cannot be greater than ${MAX_LIVING_AREA}.`;
      return null;
    },
  },
  {
    fields: ['Acres'],
    validate: (value) => {
      if (value == null || value === '') return null;
      const num = Number(value);
      if (Number.isNaN(num)) return 'Acreage must be a valid number.';
      if (num < 0.001) return 'Acreage cannot be less than 0.001.';
      if (num > MAX_ACRES) return `Acreage cannot be greater than ${MAX_ACRES}.`;
      return null;
    },
  },
  {
    // dupe fields are so stupid but you have different keys currently for this same fucking field in diff parts of the app.
    fields: ['Bath', 'fullBaths', 'BathsFull'],
    validate: (value) => {
      if (value == null || value === '') return null;
      const num = Number(value);
      if (Number.isNaN(num)) return 'Full Baths must be a valid number.';
      if (num < 1) return 'Full Baths cannot be less than 1.';
      return null;
    },
  },
  {
    fields: ['FinishedBasement'],
    validate: (value) => {
      if (value == null || value === '') return null;
      const num = Number(value);
      if (Number.isNaN(num)) return 'Finished Basement sqft must be a valid number.';
      if (num === 0) return null;
      if (num < 50) return 'Finished Basement sqft must be 0 or at least 50.';
      return null;
    },
  },
];

export const validateInventoryUpdates = (updatesByParcel = {}) => {
  const violations = [];

  Object.entries(updatesByParcel).forEach(([parcelId, updates]) => {
    INVENTORY_UPDATE_PROTECTIONS.forEach(({ fields, validate }) => {
      fields.forEach((field) => {
        if (!(field in updates)) return;
        const message = validate(updates[field], updates, parcelId);
        if (message) {
          violations.push({ parcelId, field, message });
        }
      });
    });
  });

  return { isValid: violations.length === 0, violations };
};

export const formatInventoryUpdateValidationErrors = ({ violations }) =>
  `Invalid inventory update: ${violations.map(({ message }) => message).join(' ')}`;
